export default str => !!str && !/^(false|0)$/i.test(str);
